import { NgModule } from '@angular/core';
import { ListBankComponent } from './components/list-bank/list-bank.component';
import { AddBankComponent } from './modals/add-bank/add-bank.component';
import { EditBankComponent } from './modals/edit-bank/edit-bank.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { QuillModule } from 'ngx-quill';
import { SelectDropDownModule } from 'ngx-select-dropdown';

const MODULES = [
  MatIconModule,
  MatFormFieldModule,
  MatTableModule,
  MatPaginatorModule,
  MatDialogModule,
  FormsModule,
  ReactiveFormsModule,
  MatSelectModule,
  MatInputModule,
  FlexLayoutModule,
  MatButtonModule,
  MatCardModule,
  MatMenuModule,
  MatSortModule,
  MatListModule,
  DragDropModule,
  MatSlideToggleModule,
  MatTooltipModule,
  QuillModule,
  MatStepperModule,
  MatExpansionModule,
  MatDatepickerModule,
  MatNativeDateModule,
  SelectDropDownModule,
  MatCheckboxModule,
  MatProgressBarModule
]

@NgModule({
  declarations: [ListBankComponent, AddBankComponent, EditBankComponent],
  imports: [
    CommonModule,
    ...MODULES
  ],
  exports: [
    ListBankComponent
  ]
})
export class BanksModule { }
